// Write your code here
import {Component} from 'react'
import './index.css'

import SuggestionItem from '../SuggestionItem'

class GoogleSuggestions extends Component {
  state = {sI: ''}

  onChangeSearch = event => {
    this.setState({sI: event.target.value})
  }

  updateSearch = suggestion => {
    this.setState({sI: suggestion})
  }

  render() {
    const {suggestionsList} = this.props
    const {sI} = this.state
    const filteredSuggestions = suggestionsList.filter(each =>
      each.suggestion.toLowerCase().includes(sI.toLowerCase()),
    )
    return (
      <div className="bg">
        <div className="Cont">
          <img
            src="https://assets.ccbp.in/frontend/react-js/google-logo.png"
            alt="google logo"
            className="google"
          />
          <div className="search-cont">
            <div className="bar">
              <img
                src="https://assets.ccbp.in/frontend/react-js/google-search-icon.png"
                alt="search icon"
                className="icon"
              />
              <input
                type="search"
                placeholder="Search Google"
                value={sI}
                onChange={this.onChangeSearch}
              />
            </div>
            <ul className="suggest">
              {filteredSuggestions.map(each => (
                <SuggestionItem
                  key={each.id}
                  suggestionText={each.suggestion}
                  selectSuggestion={this.updateSearch}
                />
              ))}
            </ul>
          </div>
        </div>
      </div>
    )
  }
}
export default GoogleSuggestions
